/**
 * @desc 查询
 */
const URL = "/rantion-aider";
import http, { updateResponse } from "@/http";
export function request(params: API.aider.messageLog.query.Params, options?: any) {
  return updateResponse(
    http(URL + `/message/log/query`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
